






























































import Vue from 'vue'
import Component from 'vue-class-component'
import * as t from '@/types'
import steps from '@/steps'
import { Getter, Action } from 'vuex-class'
import validateEmail from '@/validateEmail'
import store from '@/store'

import resultChart from '@/components/resultChart.vue'
import resultPie from '@/components/resultPie.vue'
import navigation from '@/components/navigation.vue'

@Component({
  components: { resultChart, resultPie, navigation },
})
export default class Results extends Vue {
  private currencySymbol = t.currencySymbol
  private steps = steps
  private financeAreas = [
    t.FinanceArea.Debt,
    t.FinanceArea.Budgeting,
    t.FinanceArea.Savings,
    t.FinanceArea.Protection,
    t.FinanceArea.Retirement,
    t.FinanceArea.Investing,
    t.FinanceArea.Planning,
  ]

  @Getter private email!: string
  @Action private setEmail!: (email: string) => void

  @Getter private settingSave!: string
  @Action private setSettingSave!: (value: string) => Promise<void>
  @Getter private settingCompare!: string
  @Action private setSettingCompare!: (value: string) => Promise<void>
  @Getter private settingFinanceAreas!: string[]
  @Action private toggleFinanceArea!: (value: string) => Promise<void>
  @Getter private settingConsent!: string
  @Action private setSettingConsent!: (value: string) => Promise<void>

  @Getter private isStepCompleted!: (step: t.StepDefinition) => boolean

  @Getter private annualIncome!: number
  @Getter private annualHousehold!: number
  @Getter private annualDay2Day!: number
  @Getter private annualPersonal!: number
  @Getter private annualDebtRepayments!: number
  @Getter private annualProtection!: number
  @Getter private annualSavingsPayments!: number
  @Getter private annualExpenses!: number
  @Getter private monthlyDifference!: number
  @Getter private monthlyIncome!: number
  @Getter private monthlyExpenses!: number

  buttonClass (name: string) {
    const areas = new Set(this.settingFinanceAreas)
    return areas.has(name) ? 'button-selected' : ''
  }

  settingSaveClass () {
    return this.settingSave === '' ? 'value-empty' : ''
  }

  settingCompareClass () {
    return this.settingCompare === '' ? 'value-empty' : ''
  }

  emailClass () {
    if (this.email.length === 0 || validateEmail(this.email)) {
      return ''
    }
    return 'email-invalid'
  }

  updateEmail (email: string) {
    this.setEmail(email)
  }

  get budgetData () {
    return [
      // { value: this.annualIncome, tooltip: `Income: ${this.currencySymbol}${this.annualIncome}` },
      {
        value: this.annualHousehold,
        link: steps.step2.link,
        tooltip: `Household: ${this.currencySymbol}${this.annualHousehold}`
      },
      {
        value: this.annualDay2Day,
        link: steps.step3.link,
        tooltip: `Day2Day: ${this.currencySymbol}${this.annualDay2Day}`
      },
      {
        value: this.annualPersonal,
        link: steps.step4.link,
        tooltip: `Personal: ${this.currencySymbol}${this.annualPersonal}`
      },
      {
        value: this.annualDebtRepayments,
        link: steps.step5.link,
        tooltip: `DebtRepayments: ${this.currencySymbol}${this.annualDebtRepayments}`
      },
      {
        value: this.annualProtection,
        link: steps.step6.link,
        tooltip: `Protection: ${this.currencySymbol}${this.annualProtection}`
      },
      {
        value: this.annualSavingsPayments,
        link: steps.step7.link,
        tooltip: `Protection: ${this.currencySymbol}${this.annualSavingsPayments}`
      },
    ]
  }
}
